import React, { useRef } from "react";
import { Layout } from "antd";
import { Navigation } from "../../components/navigation";
import FooterComponent from "../../components/Footer";
import bgDesktopVideo from '../../assets/videos/bg-desktop2.mp4'
import "./mainLayout.css";
import { FullPageHeader } from "./FullPageHeader";
import { FullPageContact } from "./FullPageContact";
import LastEdition from "../Lastedition";

const { Header, Content, Footer } = Layout;

const MainLayout = () => {
    const leftSectionRef = useRef(null);
    const contactRef = useRef(null);
    const homeRef = useRef(null);

    const scrollToHome = () => {
         // 📱 Mobile view
  if (window.innerWidth <= 768) {
    if (homeRef.current) {
      homeRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }
    return;
  }
  if (leftSectionRef.current && homeRef.current) {
    const containerTop =
      leftSectionRef.current.getBoundingClientRect().top;

    const homeTop =
      homeRef.current.getBoundingClientRect().top;

    const scrollPosition =
      homeTop - containerTop + leftSectionRef.current.scrollTop;

    leftSectionRef.current.scrollTo({
      top: scrollPosition,
      behavior: "smooth",
    });
  }
};
    const scrollToContact = () => {
        console.log('iam here');

         // 📱 Mobile view
  if (window.innerWidth <= 768) {
    if (contactRef.current) {
      contactRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }
    return;
  }
        
        if (leftSectionRef.current && contactRef.current) {
             console.log('now iam here');
            leftSectionRef.current.scrollTo({
                top: contactRef.current.offsetTop,
                behavior: "smooth"
            });
        }
    };
    return (
        <Layout className="main-layout">

            {/* Header */}
            <Header  className="header">
                <Navigation onClickHome={scrollToHome} onRsvpClick={scrollToContact} />
            </Header>

            {/* Content */}
            <Content className="content-wrapper">
                <div className="content-container">

                    {/* Left Scrollable Section */}
                    <div ref={leftSectionRef} className="left-section">
                        <section ref={homeRef} className="section">
                            <FullPageHeader onRsvpClick={scrollToContact} />
                        </section>

                        <section ref={contactRef} className="section">
                            <FullPageContact />
                        </section>

                        {/* <section className="section">
                            <h2>Contact Us</h2>
                            <p>Yeh contact section hai.</p>
                        </section> */}
                    </div>

                    {/* Right Fixed Video Section */}
                    <div className="right-section">
                        <video
                            autoPlay
                            muted
                            loop
                            playsInline
                            preload="auto"
                            className="background-video"
                        >
                            <source src={bgDesktopVideo} type="video/mp4" />
                        </video>
                    </div>

                </div>
            </Content>
<Content className="last-edition-wrapper">
    <LastEdition />
  </Content>
            {/* Footer */}
            
            <Footer className="footer">
                <FooterComponent />
            </Footer>

        </Layout>
    );
};

export default MainLayout;